import PlacanjeService from '@/services/PlacanjeService'

export const namespaced = true

export const state = {
  cenovnik: [],
  korpa: [
    // {
    //   redni_broj: 1,
    //   broj_tablica: 'PN111222',
    //   tip_kartte: 'DK06',
    //   primalac: '',
    //   jedinicna_cena: 1000.0,
    //   kolicina: 1,
    //   iznos: 1000.0,
    //   uplatilac: '',
    //   broj_racuna: '',
    //   svrha_uplate: 'Општа дневна карта',
    //   poziv_na_broj: '',
    //   datum_od: new Date(),
    //   datum_do: new Date()
    // }
  ],
  uplatilac: null,
  email: null,
  narudzbinaId: null,
  paymentBaseUrl: null
}

export const mutations = {
  SET_CENOVNIK(state, cenovnik) {
    state.cenovnik = cenovnik
  },
  ADD_KORPA(state, stavka) {
    state.korpa.push(stavka)
  },
  DELETE_KORPA(state, index) {
    state.korpa.splice(index, 1) // 0 based index
  },
  CLEAR_KORPA(state) {
    state.korpa = []
    state.uplatilac = null
    state.email = null
    state.narudzbinaId = null
  },
  SET_UPLATILAC(state, uplatilac) {
    state.uplatilac = uplatilac
  },
  SET_EMAIL(state, email) {
    state.email = email
  },
  SET_PODACIPLACANJA(state, podaciPlacanja) {
    state.narudzbinaId = podaciPlacanja.narudzbina_id
    state.paymentBaseUrl = podaciPlacanja.payment_base_url
  }
}

export const actions = {
  dajCenovnik({ commit }) {
    // service
    return PlacanjeService.dajCenovnik().then(response => {
      commit('SET_CENOVNIK', response.data.podaci)
    })
  },
  dodajUKorpu({ commit }, stavka) {
    commit('ADD_KORPA', stavka)
  },
  obrisiStavkuKorpe({ commit }, index) {
    commit('DELETE_KORPA', index)
  },
  sacuvajKorpu({ commit }, korpa, checkoutId) {
    // service
    return PlacanjeService.sacuvajKorpu(korpa, checkoutId).then(() => {
      // ne ovde nego kad dobijem potvrdu da je placanje uspesno
      // ipak ostaje ovde
      commit('CLEAR_KORPA')
    })
  },
  ocistiKorpu({ commit }) {
    commit('CLEAR_KORPA')
  },
  updateUplatilac({ commit }, uplatilac) {
    commit('SET_UPLATILAC', uplatilac)
  },
  updateEmail({ commit }, email) {
    commit('SET_EMAIL', email)
  },
  updatePodaciPlacanja({ commit }, podaciPlacanja) {
    commit('SET_PODACIPLACANJA', podaciPlacanja)
  }
}

export const getters = {
  izmenaZabranjena: state => {
    if (state.narudzbinaId) {
      return true
    } else {
      return false
    }
  },
  ukupnoZaUplatu: state => {
    //debugger
    let u = 0
    for (let index = 0; index < state.korpa.length; index++) {
      u += state.korpa[index].iznos
    }
    return u
  },
  dajStavkuCenovnikaPoId: state => id => {
    // nece ???
    // return state.cenovnik.find(stavka => {
    //   debugger
    //   console.log(stavka.id)
    //   stavka.Id === id
    // })

    //debugger
    for (let index = 0; index < state.cenovnik.length; index++) {
      //debugger
      if (state.cenovnik[index].id == id) {
        return state.cenovnik[index]
      }
    }
    return null
  },
  dajStavkeCenovnikaPoVrstiKarte: state => vrstaKarte => {
    // nece ???
    // return state.cenovnik.find(stavka => {
    //   debugger
    //   console.log(stavka.id)
    //   stavka.Id === id
    // })

    if (!vrstaKarte) {
      return state.cenovnik
    }

    let filtriraneStavke = []

    for (let index = 0; index < state.cenovnik.length; index++) {
      //debugger
      if (state.cenovnik[index].id.substring(0, 2) == vrstaKarte) {
        filtriraneStavke.push(state.cenovnik[index])
      }
    }
    return filtriraneStavke
  }
}
